import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Rating } from '../../../core/models/models';

interface UserRatingsSliceState {
  ratings: Record<string, Rating>;
}

const initialState: UserRatingsSliceState = {
  ratings: {},
};

export const UserRatingsSlice = createSlice({
  name: 'employer/rate_candidates',
  initialState,
  reducers: {
    setProposalRating(
      state,
      { payload }: PayloadAction<{ proposalId: string; rating: Rating }>
    ) {
      state.ratings[payload.proposalId] = payload.rating;
    },
  },
});

export const { setProposalRating } = UserRatingsSlice.actions;

export default UserRatingsSlice.reducer;
